import { useState } from 'react'
import { shouldDefineMax } from '../utils/graph'

const defaultActiveSeriesHandle = s => {
  return {
    name: s.name,
    data: s.data,
    color: s.color,
    group: s.group,
  }
}

const useCustomLegend = ({ initalLegendState, data, activeSeriesHandle }) => {
  const [visibleSeries, setVisibleSeries] = useState(initalLegendState)

  const toggleSeries = type => {
    setVisibleSeries(prev => ({ ...prev, [type]: !prev[type] }))
  }

  const filteredActiveSeries = data?.filter(
    serie => visibleSeries[serie.type] !== false,
  )

  const activeSeries = activeSeriesHandle
    ? filteredActiveSeries?.map(activeSeriesHandle)
    : filteredActiveSeries?.map(defaultActiveSeriesHandle)

  const flatAllData = activeSeries.map(serie => serie.data).flat()

  const defineMax = () => {
    return shouldDefineMax({
      flatData: flatAllData,
      gateValue: 50,
      maxChartValue: 100,
    })
  }

  return {
    visibleSeries,
    toggleSeries,
    activeSeries,
    defineMax,
  }
}

export default useCustomLegend
